// Each type of art a profile can be tagged with, plus the styles/genres available
// once that type is selected. "Artist" is not just music — a profile can be any
// combination of these (e.g. both a musician and a painter).
export const ARTIST_TYPES = [
    {
        key: 'music',
        label: 'Music',
        genres: [
            'Pop', 'Rock', 'Hip-Hop', 'R&B', 'Electronic', 'Jazz', 'Classical',
            'Country', 'Folk', 'Reggae', 'Blues', 'Alternative', 'Indie',
            'Metal', 'Punk', 'Soul', 'Funk', 'Disco', 'House', 'Techno',
            'Ambient', 'World', 'Latin', 'Gospel', 'Opera', 'Jam', 'Progressive',
            'Psychedelic', 'Synthwave'
        ]
    },
    {
        key: 'painting',
        label: 'Painting',
        genres: [
            'Abstract', 'Realism', 'Impressionism', 'Watercolor', 'Oil Painting',
            'Acrylic', 'Portrait', 'Landscape', 'Surrealism', 'Pop Art',
            'Street Art', 'Mixed Media', 'Fine Art'
        ]
    },
    {
        key: 'graphic',
        label: 'Graphic Design',
        genres: [
            'Illustration', 'Branding', 'Typography', 'Motion Graphics', 'UI/UX',
            'Digital Art', 'Concept Art', 'Vector Art', 'Poster Design',
            'Packaging Design', '3D Design'
        ]
    },
    {
        key: 'performance',
        label: 'Performance Art',
        genres: [
            'Theater', 'Comedy', 'Spoken Word', 'Improv', 'Circus Arts',
            'Puppetry', 'Drag', 'Magic', 'Stand-Up', 'Live Art'
        ]
    },
    {
        key: 'dance',
        label: 'Dance',
        genres: [
            'Ballet', 'Hip-Hop', 'Contemporary', 'Jazz Dance', 'Tap',
            'Ballroom', 'Breakdance', 'Salsa', 'Modern', 'Folk Dance'
        ]
    },
    {
        key: 'photography',
        label: 'Photography',
        genres: [
            'Portrait', 'Landscape', 'Street', 'Fashion', 'Wildlife',
            'Documentary', 'Fine Art', 'Product', 'Wedding', 'Astrophotography'
        ]
    },
    {
        key: 'sculpture',
        label: 'Sculpture',
        genres: [
            'Clay', 'Metal', 'Wood', 'Stone', 'Glass',
            'Found Object', 'Ceramics', 'Installation'
        ]
    },
    {
        key: 'writing',
        label: 'Writing',
        genres: [
            'Poetry', 'Fiction', 'Non-Fiction', 'Screenwriting', 'Songwriting',
            'Spoken Word', 'Journalism', 'Playwriting'
        ]
    },
    {
        key: 'film',
        label: 'Film & Video',
        genres: [
            'Documentary', 'Narrative', 'Animation', 'Experimental',
            'Music Video', 'Short Film', 'Cinematography'
        ]
    },
    {
        key: 'fashion',
        label: 'Fashion Design',
        genres: [
            'Streetwear', 'Haute Couture', 'Sustainable Fashion',
            'Costume Design', 'Accessories', 'Textile Design'
        ]
    },
    {
        key: 'other',
        label: 'Other',
        genres: []
    }
];

export const getArtistTypeLabel = (typeKey) =>
    ARTIST_TYPES.find(t => t.key === typeKey)?.label || typeKey;

// Single source of truth for the music genre list, reused by the audio upload/edit
// forms too so it can never drift out of sync with the artist profile's list.
export const MUSIC_GENRES = ARTIST_TYPES.find(t => t.key === 'music').genres;
